import api, {handleAPIErrors} from 'shared/api'

const FETCH_REQUEST = 'skillDiversity/FETCH_REQUEST';
const FETCH_SUCCESS = 'skillDiversity/FETCH_SUCCESS';
const FETCH_FAILURE = 'skillDiversity/FETCH_FAILURE';

const initialState = {
    result: {
        analysis: {},
        company_board_members: [],
        superannuation_board_members: [],
        skills_and_experience: []
    },
    loaded: false,
    loading: false,
    errors: []
};

export function fetchRequest(payload = {}) {
    return {
        type: FETCH_REQUEST
    }
}

export function fetchSuccess(payload) {
    return {
        type: FETCH_SUCCESS,
        payload,
    }
}

export function fetchFailure(errors = []) {
    return {
        type: FETCH_FAILURE,
        errors,
    }
}

export function loadSkillDiversitiesData(options = {}) {
    return (dispatch) => {
        dispatch(fetchRequest());

        return api('api/v1/skill_and_diversities/', options, {}, true)
          .then(response => response.json().then(json => ({ json, response })))
          .then(({ json, response }) => {
              if (!response.ok) {
                  return Promise.reject(json)
              }

              dispatch(fetchSuccess(json))
          })
          .catch((exception) => {
              handleAPIErrors(exception, (errors) => {
                  dispatch(fetchFailure(errors))
              })
          });
    }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
    const { payload, type, errors } = action;

    switch (type) {
        case FETCH_REQUEST:
            return Object.assign({}, state, {
                loading: true,
            });
        case FETCH_SUCCESS:
            return Object.assign({}, state, {
                loading: false,
                loaded: true,
                errors: [],
                result: payload
            });
        case FETCH_FAILURE:
            return Object.assign({}, state, {
                loaded: false,
                loading: false,
                errors,
            });
        default:
            return state
    }
}
